class Session {

    getItem(item) {
        try {
            const str = sessionStorage.getItem(item);

            return JSON.parse(str);
        } catch(error) {
            console.warn(error);
            return {};
        }
    }

    setItem(key, item) {
        try {
            const data = JSON.stringify(item);
            sessionStorage.setItem(key, data);
        } catch(error) {
            console.warn(error);
            return {};
        }
    }
}

export default new Session();



// WEBPACK FOOTER //
// ./src/Session.js